// Door panel model sketches (SINGLE/MULTI/FLAT/BLOCKS/MULTI RIB) — polygon
// renderings matching the RTH catalog: sloped parallelogram bodies, white gap
// bands following the slope, perspective trapezoid for MULTI RIB
const RIBS = [
  [80, 80], [75.6, 72.9], [71.1, 65.8], [66.7, 58.7], [62.2, 51.6],
  [57.8, 44.4], [53.3, 37.3], [48.9, 30.2], [44.4, 23.1], [40, 16],
];

export const PanelSketch = ({ model }) => {
  // right trapezoid like the catalog: BOTTOM edge horizontal, TOP edge slopes
  // up to the right (right side taller) — side-opening effect
  const body = '8,30 112,14 112,88 8,88';
  return (
    <svg viewBox="0 0 120 100" className="w-full h-full" aria-hidden="true">
      {model !== 'multirib' && (
        <>
          <polygon points={body} fill="#2E3E52" />
          {model === 'single' && <polygon points="8,56 112,48 112,51 8,59" fill="#FFFFFF" />}
          {model === 'multi' && (
            <>
              <polygon points="8,43 112,31 112,34 8,46" fill="#FFFFFF" />
              <polygon points="8,57.5 112,49.5 112,52.5 8,60.5" fill="#FFFFFF" />
              <polygon points="8,72 112,68 112,71 8,75" fill="#FFFFFF" />
            </>
          )}
          {model === 'blocks' && (
            <>
              <polygon points="36,41.5 84,29 84,73 36,76.5" fill="none" stroke="#FFFFFF" strokeWidth="2.5" />
              <polygon points="43,47.5 77,35 77,67 43,70.5" fill="none" stroke="#FFFFFF" strokeWidth="2" />
            </>
          )}
        </>
      )}
      {model === 'multirib' && (
        <>
          <polygon points="8,34 112,10 112,88 8,88" fill="#2E3E52" />
          {RIBS.map(([l, r], i) => <line key={i} x1="8" y1={l} x2="112" y2={r} stroke="#FFFFFF" strokeWidth="1.5" />)}
        </>
      )}
    </svg>
  );
};
